/**
 * Copyright IBM Corp. 2022, 2026
 */

export type ModalType = 'pdf' | 'video' | 'externalLink'

export const getModalType = (href: string): ModalType => {
	if (href.includes('.pdf')) {
		return 'pdf'
	}

	if (href.includes('youtube')) {
		return 'video'
	}

	return 'externalLink'
}
